import React, { forwardRef } from "react";
import { cn } from "@/utils/cn";

const Input = forwardRef(({ 
  className, 
  type = "text",
  error,
  label,
  ...props 
}, ref) => {
  const baseClasses = "flex w-full rounded-lg border bg-white px-3 py-2.5 text-sm transition-all duration-200 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50";
  
  const normalClasses = "border-gray-300 focus:border-facebook focus:ring-facebook hover:border-gray-400";
  const errorClasses = "border-red-300 focus:border-red-500 focus:ring-red-500";

  return (
    <div className="space-y-1.5">
      {label && (
        <label className="text-sm font-medium text-gray-700">{label}</label>
      )}
      <input
        type={type}
        className={cn(
          baseClasses,
          error ? errorClasses : normalClasses,
          className
        )}
        ref={ref}
        {...props}
      />
      {error && (
        <p className="text-sm text-red-600">{error}</p>
      )}
    </div>
  );
});

Input.displayName = "Input";

export default Input;